import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MbscModule } from '@mobiscroll/angular';
import { SharedModule } from '../../shared/shared.module';
import { SchedulerListComponent } from '../scheduler/scheduler-list/scheduler-list';
import { NewTimeOffComponent } from '../time-off/new-time-off/new-time-off';

import { ActivitiesDetailsPaneComponent } from './activities-details-pane/activities-details-pane';
import { ActivitiesPaneComponent } from './activities-pane/activities-pane';
import { EmailActivityDetailComponent } from './email-activity-detail/email-activity-detail';
import { RemoteURLEmailTemplate } from './email-template/email-template';
import { FollowUpActionDetailComponent } from './follow-up-action-detail/follow-up-action-detail';
import { NewActivityComponent } from './new-activity/new-activity';
import { NewSampleActivityComponent } from './new-sample-activity/new-sample-activity';
import { ScientificActivityDetail } from './scientific-activity/scientific-activity-detail/scientific-activity-detail';
import { ScientificActivityInfo } from './scientific-activity/scientific-activity-info/scientific-info';
import { ScientificActivityList } from './scientific-activity/scientific-activity-list/scientific-activity-list';
import { ScientificActivityPage } from './scientific-activity/scientific-activity-page/scientific-activity-page';
import { ScientificActivityTimeline } from './scientific-activity/scientific-activity-timeline/scientific-activity-timeline';
import { ScientificPlanFollowUpTask } from './scientific-activity/scientific-plan-task/scientific-plan-task';
import { ScinetificContactList } from './scientific-activity/scinetific-contact-list/scinetific-contact-list';
import { TherapeuticAreaList } from './scientific-activity/therapeutic-area/therapeuticarea.component';
import { ActivitySkeletonPaneComponent } from './activity-sekelton-pane/activity-skeleton-pane';
import { StoreCheckDetailsComponent } from './store-check-activity/store-check-details';
import { MeetingSentimentHistoryDetailComponent } from './meeting-sentiment-history-detail/meeting-sentiment-history-detail';
import { ActivityCalendarComponent } from './activity-calendar/activity-calendar';
import { ActivityChipPopoverComponent } from './activity-calendar/activity-chip-popover/activity-chip-popover.component';
import { SetBookingActivityDetailsComponent } from './set-booking-activity-detail/set-booking-activity-detail';
import { ShortCallHomeComponent } from './short-call-home/short-call-home';
import { LeftPaneUndefinedDefaultComponent } from './left-pane-undefined-default/left-pane-undefined-default';
import { CaptureSignatureMeetingComponent } from '../capture-signature-meeting/capture-signature-meeting';

// Activity-specific dependencies used only in activity templates
import { ApprovalListComponent } from '../approval-list/approval-list.component';
import { ApprovalListItemComponent } from '../approval-list-item/approval-list-item.component';
import { AppealDetailsComponent } from '../appeal-details/appeal-details.component';
import { IoContentCardsComponent } from '../io-component/io-content-cards/io-content-cards.component';
import { NextCallObjectiveComponent } from '../next-call-objective/next-call-objective';
import { SharedResourcesComponent } from '../resource/shared-resources/shared-resources';
import { ActivitiesFilterPopoverComponent } from '../activities-filter-popover/activities-filter-popover';
import { InlineAllocationOrderComponent } from './inline-allocation-order/inline-allocation-order';
import { InlineSampleDeliveryRequestComponent } from './inline-sample-delivery-request/inline-sample-delivery-request';
import { MeetingExpensesSectionComponent } from './meeting-expenses/meeting-expenses-section/meeting-expenses-section.component';
import { MeetingExpenseFormComponent } from './meeting-expenses/meeting-expense-form/meeting-expense-form.component';
// SdrNotesSectionComponent is declared here (not in SampleModule) so both the
// inline SDR editor above and the pane can use it: SampleModule imports
// ActivityModule, so its own SDR components still resolve <sdr-notes-section>
// via this module's export, while ActivityModule cannot import SampleModule
// (that would be a cycle — SampleModule -> ActivityModule already exists).
import { SdrNotesSectionComponent } from '../sample/sdr-notes-section/sdr-notes-section.component';
import { NovaMeetingContextDirective } from '../nova-voice/nova-meeting-context.directive';

const ACTIVITY_DECLARATIONS = [
  ActivitiesDetailsPaneComponent,
  ActivitiesPaneComponent,
  EmailActivityDetailComponent,
  RemoteURLEmailTemplate,
  FollowUpActionDetailComponent,
  NewActivityComponent,
  NewSampleActivityComponent,
  ScientificActivityDetail,
  ScientificActivityInfo,
  ScientificActivityList,
  ScientificActivityPage,
  ScientificActivityTimeline,
  ScientificPlanFollowUpTask,
  ScinetificContactList,
  TherapeuticAreaList,
  ActivitySkeletonPaneComponent,
  StoreCheckDetailsComponent,
  MeetingSentimentHistoryDetailComponent,
  ActivityCalendarComponent,
  ActivityChipPopoverComponent,
  SetBookingActivityDetailsComponent,
  ShortCallHomeComponent,
  LeftPaneUndefinedDefaultComponent,
  CaptureSignatureMeetingComponent,
  ApprovalListComponent,
  ApprovalListItemComponent,
  AppealDetailsComponent,
  IoContentCardsComponent,
  NextCallObjectiveComponent,
  SharedResourcesComponent,
  ActivitiesFilterPopoverComponent,
  InlineAllocationOrderComponent,
  InlineSampleDeliveryRequestComponent,
  SdrNotesSectionComponent,
  MeetingExpensesSectionComponent,
  MeetingExpenseFormComponent,
];

@NgModule({
  imports: [SharedModule, MbscModule, SchedulerListComponent, NewTimeOffComponent, NovaMeetingContextDirective],
  declarations: ACTIVITY_DECLARATIONS,
  exports: ACTIVITY_DECLARATIONS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActivityModule {}
